import requestInstance from "./Request";

const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`;

const subscriptionService = {
  // GET: Fetch all subscription plans
  async getSubscriptionList(params = {}) {
    try {
      const response = await requestInstance.get(`${BASE_URL}/admin-api/v3/subscription-plan`, {
        params,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching subscription list:", error);
      throw error;
    }
  },

  // GET: Fetch subscription by ID
  async getSubscriptionById(subscriptionId) {
    try {
      const response = await requestInstance.get(`${BASE_URL}/admin-api/v3/subscription-plan/${subscriptionId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching subscription by ID:", error);
      throw error;
    }
  },

  // PATCH: Update a subscription
  async updateSubscription(subscriptionId, updatedData) {
    try {
      const response = await requestInstance.patch(
        `${BASE_URL}/admin-api/v3/subscription-plan/${subscriptionId}`,
        updatedData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating subscription:", error);
      throw error;
    }
  },
};

export default subscriptionService;